import { IonButtons, IonCol, IonContent, IonFooter, IonGrid
  , IonHeader, IonItem, IonLabel, IonMenuButton, IonDatetime, IonFab, IonFabButton
  , IonPage, IonRow, IonTitle, IonToolbar ,IonCard, IonBadge, IonList, IonDatetimeButton
  , IonModal, IonButton, IonText, IonSpinner, IonIcon, IonAlert, IonBackButton} from '@ionic/react';
  import React, { useEffect, useState, useRef } from 'react';
  import { add, imageOutline, chevronBack, chevronForward, logInOutline, logOutOutline, calendarOutline, 
    personCircleOutline, timeOutline, clipboardOutline, locationOutline } from 'ionicons/icons';
//import { useParams } from 'react-router';
import './WorkCalendar.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import ServerService from '../../../services/Server';
import MapContainer, { MapContainerRef } from '../../../components/MapContainer';
import { useIonRouter } from '@ionic/react';
import { Environment } from "../../../data/Environment";
const Con: React.FC = () => {
 const router = useIonRouter();
 const [selectedDate, setSelectedDate] = useState<string>(new Date().toISOString());
 const [listActivityDtl, setListActivityDtl] = useState<any[]>([]);
 const [events, setEvents] = useState([
  { date: '2026-03-04', count: 3 }, // วันนี้มี 3 งาน
  { date: '2026-03-05', count: 1 },
  { date: '2026-03-10', count: 5 },
]);
const [totalTask, setTotalTask] = useState<string>("");
const server = new ServerService();
const state = server.state;
const data = {username:state.username, password:state.password}


const fetchActivityDtl = function(date : string) {
  const data = { 
    alf_ticket : state.ticket,
    selectedDate : date.split('T')[0]
  }
  fetch(server.getFullUrl("activity/mb/listActivityDtl", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if(result.status=='E'){
        return false;
      }else{
        setListActivityDtl(result.data);
        setTotalTask(result.data.length);
      }
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {
}) 
}

useEffect(() => {
  fetchActivityDtl(selectedDate);
}, []);

const selectCalendar = (date : string) =>{
  setSelectedDate(date);
  fetchActivityDtl(date);
  
}

const handleOpenActivity = (id: number, dtlid: number, rec : any) => {
//console.log('ok :: ' + id + ' ' + dtlid);
if(rec.activity_status == 'W'){
  router.push('/page/home/bams/jobDetail/'+id+"/"+dtlid);
}
};

 return (
 
  <IonPage>
  <IonHeader className="blue-header">
  <IonToolbar color="primary">
   
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between', 
      width: '100%',
      padding: '0 16px' 
    }}>
      
      
      <div style={{ flex: 1, textAlign: 'left' }}>
        <IonText style={{ fontSize: '0.85rem', opacity: 0.9 }}>
          
        </IonText>
      </div>

     
      <div style={{ flex: 2, textAlign: 'center' }}>
        <IonText style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
        กิจกรรม
        </IonText>
      </div>

      
      <div style={{ flex: 1, textAlign: 'right' }}>
        {/* <IonIcon icon={personCircleOutline} style={{ fontSize: '24px' }} /> */}
      </div>
      
    </div>
  </IonToolbar>
</IonHeader>
<IonContent color="light">
       
<div>
<IonDatetimeButton datetime="datetime"></IonDatetimeButton>

<IonModal keepContentsMounted={true}>
<IonDatetime
    presentation="date"
    id="datetime"
    value={selectedDate}
    onIonChange={e => selectCalendar(e.detail.value as string)}
   // onIonChange={e => setSelectedDate(e.detail.value as string)}
    locale="th-TH"
    size="cover"
  />
</IonModal>
</div>

<div style={{ 
  background: '#3880ff', 
  color: 'white', 
  padding: '10px 16px', 
  display: 'flex', 
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
  zIndex: 10
}}>
  <IonText style={{ fontSize: '0.9rem' }}>
    กิจกรรมในวันที่ {new Date(selectedDate).toLocaleDateString('th-TH', { day: '2-digit', month: 'long', year: 'numeric' })}
  </IonText>
  <IonText style={{ fontSize: '0.9rem' }}>{totalTask} แผน</IonText>
</div>

        <IonList lines="full" className="ion-no-padding">
        {listActivityDtl.map((item, index) => (
          <IonItem key={index} style={{ '--padding-start': '16px' }}
          onClick={() => handleOpenActivity(item.id, item.dtl_id, item)}
          >
  
    <div slot="start" style={{ 
      background: '#4db6ac', 
      width: '50px', 
      height: '50px', 
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white'
    }}>
      <IonIcon icon={imageOutline} style={{ fontSize: '24px' }} />
    </div>

    <IonLabel>
  
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
    {/*<IonBadge color="primary" style={{ fontSize: '0.7rem' }}>ปกติ</IonBadge>*/}
    <IonText style={{ fontWeight: 'bold', fontSize: '0.8rem' }}>{item.name}</IonText>
  </div>
  
  
  <div style={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    marginTop: '4px' 
  }}>
    <IonBadge color="secondary" mode="ios" style={{ 
      fontSize: '0.7rem', 
      fontWeight: 'normal',
      '--background': '#4dd0e1',
      color: 'white' 
    }}>
      รอการปฏิบัติงาน
    </IonBadge>

    
    <IonText color="dark" style={{ fontSize: '0.85rem', fontWeight: '500' }}>
      {item.start_time_text} - {item.end_time_text}
    </IonText>
  </div>

  
  <div style={{ marginTop: '8px' }}>
    <IonText color="primary" style={{ fontSize: '0.8rem', display: 'flex', alignItems: 'center' }}>
       {item.activity_name}
    </IonText>
  </div>
  <div style={{ marginTop: '8px' }}>
    <IonText color="primary" style={{ fontSize: '0.8rem', display: 'flex', alignItems: 'center' }}>
       <IonIcon icon={locationOutline} style={{ marginRight: '4px', fontSize: '14px' }} />
       {item.flag5} {item.flag7} {item.flag8} {item.flag9}
    </IonText>
  </div>
</IonLabel>
  </IonItem>
        ))}
  
</IonList>

       
        <IonFab vertical="bottom" horizontal="end" slot="fixed" className="custom-fab">
  <IonFabButton color="secondary" size="small">
    <IonIcon icon={add} />
  </IonFabButton>
</IonFab>
      </IonContent>

</IonPage>

 );
};

export default Con;
